import { createApi } from '@reduxjs/toolkit/query/react'

import { rtkBaseQuery } from '../../api'

export const meApi = createApi({
  baseQuery: rtkBaseQuery,
  reducerPath: 'meApi',
  tagTypes: ['Me', 'CsrfToken'],
  endpoints: (builder) => ({
    getMyData: builder.query({
      query: () => '/v1/users/me/',
      providesTags: ['Me']
    }),
    accountsByUserEmail: builder.mutation({
      query: (payload) => {
        return {
          url: '/v1/user/accounts',
          method: 'POST',
          body: {
            email: payload
          }
        }
      },
      invalidatesTags: ['Me']
    }),
    getCsrfToken: builder.query({
      query: () => {
        return {
          url: '/v1/csrf-token'
        }
      },
      providesTags: ['CsrfToken']
    }),
    logout: builder.mutation({
      query: () => {
        return {
          method: 'POST',
          url: 'v1/logout'
        }
      },
      invalidatesTags: ['Me', 'CsrfToken']
    })
  })
})

export const { useGetMyDataQuery, useLogoutMutation, useAccountsByUserEmailMutation, useGetCsrfTokenQuery } = meApi

export default meApi
